import { lazy } from 'react';
import { authRoles } from 'app/auth';

const Announcements = lazy(() => import('./AnnouncementsPage'));

const AnnouncementsConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'announcements',
      element: <Announcements />,
    },
  ],
};

export default AnnouncementsConfig;
